import CloneError from "./CloneError.mjs";
class DeepCloneError extends CloneError {}
export default DeepCloneError;